/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlan/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlan({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/AcceptTreatmentAction/Content/Selection/TreatmentPlan"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let selectedTreatmentPlanIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'treatment_plan_id',
})
let treatmentPlanIdValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: '_id',
})
let aggregateData = fromAggregate.equals(selectedTreatmentPlanIdValueData, treatmentPlanIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let selectedTreatmentPlanIdValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'treatment_plan_id',
})
let treatmentPlanIdValueData1 = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: '_id',
})
let aggregateData1 = fromAggregate.equals(selectedTreatmentPlanIdValueData1, treatmentPlanIdValueData1)
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let treatmentPlanNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: 'name',
})
let treatmentPlanAppointmentsValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_plan',
path: 'appointments',
format: fromHelpers.getSubtitle,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="TreatmentPlan.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-8-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-9-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-10-b2MGG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-b2MGG': aggregateData ? dtColorsGreen600 : dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="selected.treatment_plan_id"
 data="treatment_plan._id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
 onClick={onClick1}
 paddingBottom={0}
 paddingRight={0}
 paddingTop={0}
/>
<div
  data-testid="TreatmentPlan.Vertical"
  data-view-path={viewPath}
 style={{'--g-10-b2MGG': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="treatment_plan.name"
 text={treatmentPlanNameValueData}
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="treatment_plan.appointments"
 format="helpers.js getSubtitle"
 text={treatmentPlanAppointmentsValueData}
/>
</div>
</button>
{children}
</React.Fragment>)
}